import { Controller } from '@hotwired/stimulus'
import { ahoy } from '../../helpers/analyticsTracker'

// Declarative analytics tracking controller.
//
// Usage examples:
//
// Track on click:
//   <button data-controller="analytics--track"
//           data-action="click->analytics--track#track"
//           data-analytics--track-event-value="button_click"
//           data-analytics--track-properties-value='{"button":"export_pdf"}'>
//
// Track on connect (e.g. modal open):
//   <div data-controller="modal analytics--track"
//        data-analytics--track-event-value="modal_open"
//        data-analytics--track-properties-value='{"modal":"new_site_task"}'
//        data-analytics--track-on-value="connect">
//
// Track on form submit:
//   <form data-controller="analytics--track"
//         data-action="submit->analytics--track#track"
//         data-analytics--track-event-value="form_submit"
//         data-analytics--track-properties-value='{"form":"site_task_create"}'>
export default class extends Controller {
  static values = {
    event: String,
    properties: { type: Object, default: {} },
    on: String, // 'connect' or 'visible'
  }

  connect() {
    if (this.onValue === 'connect') {
      this.track()
    }

    if (this.onValue === 'visible') {
      this.#observeVisibility()
    }
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  track() {
    if (!this.hasEventValue) return

    ahoy.track(this.eventValue, this.propertiesValue)
  }

  #observeVisibility() {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.track()
            this.observer.disconnect()
          }
        })
      },
      { threshold: 0.5 },
    )

    this.observer.observe(this.element)
  }
}
